import { SelectProps } from "@cofano/cck/Select/Select";
import { DemurragePayableOver } from "__generated__/graphql";
import { Select } from "@cofano/cck";
import { intl } from "LocaleWrapper";

const DemurragePayableOverSelect = ({ value, onChange }: Omit<SelectProps<DemurragePayableOver, false>, "fetchOptions">) => {
	return (
		<Select
			fetchOptions={Object.values(DemurragePayableOver)}
			getOptionLabel={(option) => intl.formatMessage({ id: `DEMURRAGE_PAYABLE_OVER_${option}` })}
			value={value}
			onChange={onChange}
		/>
	);
};

export default DemurragePayableOverSelect;
